import {
  Dialog,
  DialogHeader,
  DialogContent
} from 'aquilla/core/molecules/Dialog';
import Close from '@icon/Close';
import Typography from 'aquilla/core/atoms/Typography';
import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';
import { useIsMobile } from '@stores/AppCommonData';
import { modalHeadings } from './constants';

const StyledDialog = styled(Dialog)`
  ${mediaQuery.uptoMobile} {
    max-height: 100vh;
    height: 100vh;
  }
`;

const DialogHeading = styled(Typography)`
  margin-top: ${Spacings.SPACING_8B};
`;
const DetailsRow = styled.div`
  display: flex;
  margin-bottom: ${Spacings.SPACING_3B};
  :last-child {
    margin-bottom: ${Spacings.SPACING_6B};
  }
`;
const DetailsHeading = styled(Typography)`
  display: flex;
  width: 120px;
  margin-right: ${Spacings.SPACING_2B};
  color: var(--color-text-secondary);
`;
const DetailsValue = styled(Typography)`
  display: flex;
`;

const StyledDialogContent = styled(DialogContent)`
  padding-bottom: ${Spacings.SPACING_6B};
`;

const PhysicalNotesModal = ({ data, open, handleOnClose }) => {
  const { title, description } = data;
  const isMobile = useIsMobile();
  return (
    <StyledDialog open={open} size="medium">
      <DialogHeader>
        <Close height={24} width={24} onClick={handleOnClose} />
        <DialogHeading variant="h3">{title}</DialogHeading>
      </DialogHeader>
      <StyledDialogContent>
        {Object.keys(modalHeadings).map((key, index) => {
          return (
            <DetailsRow key={String(index)}>
              <DetailsHeading variant="h5">{modalHeadings[key]}</DetailsHeading>
              <DetailsValue variant="h5">
                {Array.isArray(data[key]) ? data[key].join(', ') : data[key]}
              </DetailsValue>
            </DetailsRow>
          );
        })}
        <Typography variant={isMobile ? 'p2' : 'p1'}>{description}</Typography>
      </StyledDialogContent>
    </StyledDialog>
  );
};

export default PhysicalNotesModal;
